// extracted by mini-css-extract-plugin
export default {"help":"Help_help__JuuGX","content":"Help_content__4jqRm","icon":"Help_icon__XOfpa","text":"Help_text__bhJgS","telegramButton":"Help_telegramButton__0KWaL"};